
import { Box } from '@mui/system';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, LightBlueContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import { contractPageName } from '../components/PageName';
import { useLocation, useNavigate } from 'react-router-dom';
import FormInput from '../components/FormInput';
import { useEffect, useState } from 'react';
import FormDatePicker from '../components/FormDatePicker';
import dayjs from 'dayjs';
import FormTextarea from '../components/FormTextarea';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useLazyGetContractByIdQuery, useUpdateContractMutation } from '../features/contract/ContractSlice';
import { useTranslation } from "react-i18next";
import { AddUserContainer } from '../components/Containers/AddUserContainer';
import { useForm } from 'react-hook-form';
import HookFormInput from '../components/HookFormInput';
import HookFormDatePicker from '../components/HookFormDatePicker';
import HookFormTextarea from '../components/HookFormTextarea';

const EditContractPage = () => {
    const { t, i18n } = useTranslation();
    const getLocation = useLocation();
    const { register, getValues, handleSubmit, setValue, watch, control, setError, formState: { errors }, reset } = useForm<
        {
            number?: string
            title?: string
            startDate?: string
            endDate?: string
            remark?: string
            inspectors?: any[]
        }
    >()

    const [open, setOpen] = useState(false)
    const [setUpdateContractMutation, updateContract] = useUpdateContractMutation();
    const navigate = useNavigate()
    const [getContractById, contractById] = useLazyGetContractByIdQuery();
    const [updateStatus, setUpdateStatus] = useState("");

    useEffect(() => {
        try {
            getContractById(getLocation?.state)
                .then((response: any) => {
                    if (response.status == 'fulfilled') {
                        reset(response?.data)
                    }
                })
        } catch (error) {

        }
    }, [getLocation?.state])

    const onConfirm = async (value: any) => {
        setUpdateContractMutation(value)
            .then((respone: any) => {
                if ('error' in respone) {
                    console.log(respone.error);
                    alert("StatusCode: 400")
                    setOpen(false);
                }
                else {
                    console.log(respone.data);
                    alert("Update Success")
                    setOpen(false);
                    navigate('/contract-detail', { state: getLocation?.state })

                }
            })
    }

    const onClose = function () {
        setOpen(false)
    }

    const openModal = function () {
        setOpen(true)
    }

    return (
        <MainContent type={contractPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <BigHeading>{t("Edit Contract")}</BigHeading>

                    <HookFormInput title={t("Contract No.")} register={() => register("number")} />
                    <HookFormInput title={t("Contract Title")} register={() => register("title")} />
                    <HookFormDatePicker title={t("Start Date")} name={"startDate"} control={control} />
                    <HookFormDatePicker title={t("End Date")} name={"endDate"} control={control} />
                    <HookFormTextarea title={t("Remark")} register={() => register("remark")} />
                    <AddUserContainer
                        label={t("Add Inspector")}
                        onSelectRows={(inspectors: any[]) => {
                            setValue("inspectors", inspectors)
                        }}
                        selectedRows={watch("inspectors")}
                        role="Inspector"
                    />
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={openModal}>{t("Save")}</ShortBlueButton>
                        <BackButton onClick={() => { navigate('/contract-detail', { state: getLocation?.state }) }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>

            <ModalConfirmationBox description={"Are you sure to update this contract record? "} open={open} onClose={onClose} onConfirm={handleSubmit(onConfirm)} />
        </MainContent>
    );
};

export default EditContractPage;